<div class="box-debt" [ngClass]="{'box-debt-app': isApp}">
    <div class="info-debt">
        <div class="section-info">
            <div class="content-info order-1 order-md-0">
                <p class="title">{{debt.entityName}}</p>
            </div>
            <div class="content-info tags" [ngClass]="{'justify-content-between' : quotasAndDiscount, 'justify-content-end' : !quotasAndDiscount }" *ngIf="debt.sourceDebt == 'pad'">
                <div *ngIf="debt.discount > 0" class="tag green">{{debt.discount}}% de DCTO</div>
            </div>
        </div>
        <div class="section-info">
            <div class="content-info order-1 order-md-0">
                <div class="sub-content order-1 order-md-0 d">
                    <p>Tiempo:</p>
                    <p class="bold-black">{{debt.debtTime}}</p>
                </div>
                <div class="sub-content border-rigth-custom">
                    <p>Estado:</p>
                    <div class="info-state">
                        <p [ngClass]="getColorState(debt.stateDebt)">{{textTransform(debt.stateDebt)}}</p>
                        <div class="box-info">
                            <div class="box-pop">
                                <button (click)="switchPop($event)">&#10005;</button>
                                <p>{{textTooltipState(debt.stateDebt)}}</p>
                                <i class="fa fa-sort-down"></i>
                            </div>
                            <button (click)="switchPop($event)" class="btn-tooltip">i</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-info">
                <p class="title">{{debt.typDebt}}</p>
                <p>CTA No. {{debt.accountDebt}}</p>
            </div>
        </div>
        <div class="section-info" [ngClass]="{'show':(debt.stateDebt == 'PAGADA')}">
            <button  class="btnGeneric" [ngClass]="isAgree(debt.stateDebt)" (click)="callMethodCta()"><span
                *ngIf="!isLoadApplyPadYa">{{textCta}}</span><span class="custom-loader"
                *ngIf="isLoadApplyPadYa"></span></button>
        </div>
    </div>
</div>